import { render, staticRenderFns } from "./ModalCommoditiesExcluded.vue?vue&type=template&id=6894e172&scoped=true"
import script from "./ModalCommoditiesExcluded.vue?vue&type=script&lang=js"
export * from "./ModalCommoditiesExcluded.vue?vue&type=script&lang=js"
import style0 from "./ModalCommoditiesExcluded.vue?vue&type=style&index=0&id=6894e172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6894e172",
  null
  
)

export default component.exports